<template>
  <div>
    <v-tabs v-model="tab">
      <v-tab>
        Mês
      </v-tab>
      <v-tab>
        Semana
      </v-tab>
    </v-tabs>
    <v-container fluid>
      <v-row>
        <v-col class="d-none d-md-block" />
        <v-col>
          <div class="d-flex justify-content-center text-info align-items-center">
            <i
              class="fas text-secondary pointer-on-hover p-2 fa-chevron-left"
              @click="$refs.calendar.prev()"
            />
            <div class="py-4 text-secondary">
              <h4 class="mx-2">
                {{ months[Number(value.split('-')[1]) - 1] }} de {{ value.split('-')[0] }}
              </h4>
            </div>
            <i
              class="fas text-secondary pointer-on-hover p-2 fa-chevron-right"
              @click="$refs.calendar.next()"
            />
          </div>
        </v-col>
        <v-col class="align-items-center col d-none d-md-flex justify-content-end">
          <CreateSchedule @closeModal="getEvents()" />
        </v-col>
        <v-col md="12">
          <v-sheet height="600">
            <EventsCalendar v-if="$vuetify.mobile" />
            <v-calendar
              v-else
              ref="calendar"
              v-model="value"
              color="challenge"
              :weekdays="weekday"
              :type="type"
              :events="[...cycle_events, ...events]"
              :event-color="getEventColor"
              :event-category="getEventCategory"
              :interval-format="intervalFormat"
            />
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

import {months} from "@/constants/months";
import {getEventCategory, getEventColor, intervalFormat, data as DataObject} from "@/common/utils/calendarHelpers";
import CreateSchedule from "@/student/components/schedule/CreateSchedule";
import {mapActions, mapGetters} from "vuex";
import EventsCalendar from "@/student/components/calendar/EventsCalendar";

export default {
  components: {
    CreateSchedule,
    EventsCalendar,
  },
  data: () => ({
    ...DataObject,
    months,
    tab: 0,
    scrollStartTime: '07:30'
  }),
  computed: {
    type() {
      return this.types[this.tab]
    },
    ...mapGetters(['events','cycle_events'])
  },
  watch: {
    type: {
      handler(new_type) {
        if (new_type == "week"){
          this.$nextTick(() => {
            this.$refs.calendar.scrollToTime(this.scrollStartTime);
          })
        }
      },
      immediate: true
    },

  },
  created() {
    this.getEvents();
    this.value = this.$moment().format('Y-MM-DD')
  },
  methods: {
    ...mapActions(['getEvents']),
    getEventColor,
    getEventCategory,
    intervalFormat
  },
}
</script>
